// =============================================================================
// Module Core - Favorite Repository
// Seul fichier autorisé à importer supabase pour les favoris
// =============================================================================

import { supabase } from '@/integrations/supabase/client';
import type { Favorite, FavoriteRow } from '../types';

// ─────────────────────────────────────────────────────────────────────────────
// FETCH FAVORITES
// ─────────────────────────────────────────────────────────────────────────────
export async function fetchFavorites(
  userId: string,
  orgId: string
): Promise<Favorite[]> {
  const { data, error } = await supabase
    .from('project_favorites')
    .select(`
      id,
      project_id,
      project_projects!inner (name)
    `)
    .eq('user_id', userId)
    .eq('org_id', orgId);

  if (error) {
    console.error('Error fetching favorites:', error);
    return [];
  }

  return (data || []).map((row: { id: string; project_id: string; project_projects: { name: string } | null }) => ({
    id: row.id,
    projectId: row.project_id,
    projectName: row.project_projects?.name || '',
  }));
}

// ─────────────────────────────────────────────────────────────────────────────
// ADD FAVORITE
// ─────────────────────────────────────────────────────────────────────────────
export async function addFavorite(
  userId: string,
  orgId: string,
  projectId: string
): Promise<{ id: string } | null> {
  const { data, error } = await supabase
    .from('project_favorites')
    .insert({
      user_id: userId,
      org_id: orgId,
      project_id: projectId,
    })
    .select('id')
    .single();

  if (error) {
    console.error('Error adding favorite:', error);
    return null;
  }

  return { id: data.id };
}

// ─────────────────────────────────────────────────────────────────────────────
// REMOVE FAVORITE
// ─────────────────────────────────────────────────────────────────────────────
export async function removeFavorite(
  userId: string,
  projectId: string
): Promise<boolean> {
  const { error } = await supabase
    .from('project_favorites')
    .delete()
    .eq('user_id', userId)
    .eq('project_id', projectId);

  if (error) {
    console.error('Error removing favorite:', error);
    return false;
  }

  return true;
}
